export const TOGGLE_REVIEW_DATA_LOADING= 'ReviewPage/TOGGLE_REVIEW_DATA_LOADING';
export const UPDATE_TENTATIVE_ACTION = 'ReviewPage/UPDATE_TENTATIVE_ACTION';
export const SET_GO_SAFE_SOCIAL_DATA = 'ReviewPage/SET_GO_SAFE_SOCIAL_DATA';
export const SET_GO_SAFE_DATA = 'ReviewPage/SET_GO_SAFE_DATA'
export const SET_DEPOT_REVIEW_API = 'ReviewPage/SET_DEPOT_REVIEW_API'
export const SET_SELECTED_PROMO_CODE = 'ReviewPage/SET_SELECTED_PROMO_CODE';
export const TOGGLE_GOCASH_SELECTION = 'ReviewPage/TOGGLE_GOCASH_SELECTION';

export const UPDATE_GOTRIBE_DETAILS = 'UPDATE_GOTRIBE_DETAILS';
export const UPDATE_GOTRIBE = 'UPDATE_GOTRIBE';
